import {isArrayHaveItem} from "./listHelper";
import {ValidationExceptionModel} from "../model/core/ValidationExceptionModel";
import {ServerExceptionModel} from "../model/core/ServerExceptionModel";
import {from} from "linq-to-typescript";
import {getTypeOfObject} from "./objectHelper";
import {getTextForBlob} from "./blobHelper";


export type errorMessageType = "server"|"react"|"validation"|"axios"|"unknown"
export interface ErrorMessage{
    title:string,
    message:string
    type?:errorMessageType
    notTranslate?:boolean



}
export const GetValidationError = (error: any):ErrorMessage => {
    let stringResult = "";
    if (error !== undefined && error.errorFields !== undefined) {
        if (isArrayHaveItem(error.errorFields)) {
            const exceptions: ValidationExceptionModel[] = error.errorFields;


            exceptions.forEach(value => {
                stringResult = stringResult + `* ${value.errors?.toString?.() ?? ""}\r\n`
            })


        }
    }
    return {title:"Doğrulama Hatası",message:stringResult,type:"validation"};
}

export const IsValidationErrorString = (error: any): boolean => {
    return error !== undefined && error.errorFields !== undefined;
}

export const GetServerErrorMessage = (error: any): ServerExceptionModel => {

    if (error !== undefined && error.data !== undefined && error.data.exception !== undefined) {
        return error.data.exception as ServerExceptionModel;
    }
    else if (error !== undefined && error.exception !== undefined) {
        return error.exception as ServerExceptionModel;
    }
    return undefined as never;
}


export const IsServerErrorMessage = (error: any): boolean => {
    return GetServerErrorMessage(error) !== undefined;
}


export const IsReactError = (error: any): boolean => {
    return error?.message !== undefined;
}

export const IsAxiosError = (error: any): boolean => {
    return error?.data !== undefined && error?.status !== undefined && error?.request !== undefined;
}

export  const  GetMessageReason= async (reason:any)=>{

    if(getTypeOfObject(reason?.data) === "blob"){
        const text = await getTextForBlob(reason?.data);
        if(text){
            try {
                return  GetMessage({data:JSON.parse(text)});
            }
            catch {
                return GetMessage(text);
            }
        }else{
            return {title:"Bilinmeyen Hata", message:"Bilinmiyor" ,type:"server"} as ErrorMessage;
        }
    }else{
        return GetMessage(reason.data);
    }
}
export const GetMessage = (error: any): ErrorMessage => {
    if (error === undefined && error === null) {
        return {title:"Bilinmeyen Hata",message:"",type:"unknown"};
    } else if (IsValidationErrorString(error)) {
        return GetValidationError(error);
    } else if (IsServerErrorMessage(error)) {
        const exceptionTemp = GetServerErrorMessage(error);
        if(isArrayHaveItem(exceptionTemp.innerExceptions)){
            return {"message":exceptionTemp.message + ":\r\n"+ from(exceptionTemp.innerExceptions).select(s=>s.message).toArray().join("\r\n") ?? "",title:exceptionTemp.code,type:"server"};
        }else{
            return {"message":exceptionTemp.message ?? "",title:exceptionTemp.code,type:"server"};
        }


    } else if (IsReactError(error)) {
        return {title:error.name ?? "Bilinmeyen Hata", message:error.message ?? "",type:"react"};
    }else if (IsAxiosError(error)) {
        return {title:error.status ?? "Bilinmeyen Hata", message:error.data ?? "",type:"axios"};
    }
    else {
         return {title:"Bilinmeyen Hata",message:error?.toString?.() ?? "",type:"unknown"};
    }
}


